import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@/components/ui/button';
import { useTranslator } from '@/hooks/useTranslator';
import { useOldDashboardBanner } from './hooks/useOldDashboardBanner';

/**
 * Opt-out banner: sends the user back to the old dashboard.
 *
 * The mirror of the old frontend's `FrontendV2Banner`, which offers the trip in
 * the other direction. Dismissing is remembered in `localStorage`, and the user
 * dropdown can bring it back.
 */
export function OldDashboardBanner() {
  const { getTranslation: t } = useTranslator({ page: 'shared' });
  const { visible, leaving, handleLeave, handleDismiss } =
    useOldDashboardBanner();

  if (!visible) return null;

  return (
    // `bg-primary` + `text-primary-foreground`, not `bg-brand-accent`: the
    // accent is a light teal, so the white foreground washed out against it.
    // This pair is defined to contrast in both themes.
    <div className='flex h-11 w-full shrink-0 items-center gap-2 bg-primary px-4 text-primary-foreground'>
      <span className='flex-1 truncate text-xs'>
        {t('oldDashboardBanner.message')}
      </span>
      {/* `secondary`, not `outline` — an outline button borrows the page
          foreground, which is the same teal family as this bar. */}
      <Button
        variant='secondary'
        onClick={handleLeave}
        disabled={leaving}
        loading={leaving}
      >
        {t('oldDashboardBanner.cta')}
      </Button>
      <Button
        variant='ghost'
        size='icon'
        aria-label={t('oldDashboardBanner.dismiss')}
        onClick={handleDismiss}
        className='text-primary-foreground hover:bg-primary-foreground/10'
      >
        <FontAwesomeIcon icon={faXmark} />
      </Button>
    </div>
  );
}
